import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AgentService } from 'src/app/front-user/services/e-booking/shared/services/agent.service';
import { SmallUnitRequest } from 'src/app/front-user/services/small-units/shared/models/Small-Unit-Request.model';
import { SmallUnitsServiceFE } from 'src/app/front-user/services/small-units/shared/services/small-units.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { SUConfirmTransitDecision, FormMode, Languages, ServiceStatus, SUIsmConfirmTransitDecision } from 'src/app/shared/models/enums.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { IsmDepartureApprovalComponent } from '../ism-departure-approval/ism-departure-approval.component';
import { SmallUnitadminDTO } from '../shared/models/small-units-admin.model';
import { SmallUnitsAdminService } from '../shared/services/small-units.service.admin';

@Component({
  selector: 'app-ism-confirm-transit',
  templateUrl: './ism-confirm-transit.component.html',
  styleUrls: []
})
export class IsmConfirmTransitComponent implements OnInit {
    submitted = false;
    loading = false;
    baseRequestId: string = '';
    requestStatus: number;
    baseRequestDTO:  BaseRequest//= new BaseRequest();
    decision = SUIsmConfirmTransitDecision;
    decisionKeys = Object.keys(this.decision);
    displayedLang: string;
    decisionValue: number;
    ISMconfirmTransitForm: FormGroup;
    user: User = new User();
    agent: User = new User();
    smallunitRequestObj: SmallUnitRequest = new SmallUnitRequest();
    adminDecisionObject: SmallUnitadminDTO = new SmallUnitadminDTO();
    showRequest = false;
    agentId: string;
    public FormMode: any = FormMode;
    public formMode: any = FormMode.Add;
    isLoaded: boolean = false;
    isErrorMessage: boolean = false;
    numberRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
    @Input() public isShow: boolean = true;
    @Input() public ShowRequestdetails: boolean = true;
    @ViewChild('ISMDepartureApproval',{static: false}) ISMDepartureApproval: IsmDepartureApprovalComponent;
    responseObj: ResponseObject = new ResponseObject();
    lockTaskErrorMessage: boolean = false;


    constructor(private formBuilder: FormBuilder, private baseRequestService: BaseRequestService,
      private globalSrv: GlobalServices,
      private route: ActivatedRoute, private router: Router,
      private translate: TranslateService,
      private SmallUnitServ: SmallUnitsServiceFE,
      private authenticationService: AuthenticationService, private alertService: AlertService,
      private SmallUnitAdminServ: SmallUnitsAdminService, private agentSrv: AgentService) {
     // this.isShow = true;
      this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
      this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
      //this.baseRequestId = this.route.snapshot.params.Id;
      if (history.state.data && history.state.data.requestId) {
        this.baseRequestId = history.state.data.requestId;
        this.getBaseRequest();
      }else{
        window.history.back();
      }

      this.user = this.globalSrv.user;

    }

    ngOnInit() {

      this.buildForm(null);
    }

    buildForm(decision) {
      this.ISMconfirmTransitForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        MoreInformation: ['', [Validators.required]],
      });
      if (decision == SUIsmConfirmTransitDecision.ISM_Postpone) {
        this.ISMconfirmTransitForm = this.formBuilder.group({
          Decision: ['', [Validators.required]],
          MoreInformation: ['', [Validators.required]],
        });
      }
      else if   (decision == SUIsmConfirmTransitDecision.ISM_Confirm_Transit) {
        this.ISMconfirmTransitForm = this.formBuilder.group({
          Decision: ['', [Validators.required]],
          TransitDate: ['', [Validators.required]],
          MoreInformation: ['', [Validators.required]],
        });
      }
    }
    changeDecision(value) {
      this.buildForm(value);
      this.ISMconfirmTransitForm.patchValue({
        Decision: value
      });
      this.decisionValue = value;
    }

    get f() {
      return this.ISMconfirmTransitForm.controls;
    }

    getBaseRequest() {
      this.SmallUnitServ.get(this.baseRequestId).subscribe(
        (resObj: ResponseObject) => {
          this.responseObj = resObj;
          if (this.responseObj.Success) {
            this.smallunitRequestObj = this.responseObj.Data;
            this.requestStatus = this.smallunitRequestObj.StatusId;
            this.agentId = this.smallunitRequestObj.RequestorId;
            this.isLoaded = true;
            if (history.state.data && history.state.data.isCompleted) {
              this.decisionValue = this.smallunitRequestObj.ISMarineConfirmActionId;
              if (this.smallunitRequestObj.ISMarineConfirmActionId == SUIsmConfirmTransitDecision.ISM_Postpone) {
                this.buildForm(this.decisionValue);
                this.ISMconfirmTransitForm.patchValue({
                  Decision: this.decisionValue ,
                  MoreInformation: this.smallunitRequestObj.ISMarineConfirmMoreInformation
                });
              }
              else {
                this.buildForm(this.decisionValue);
                this.ISMconfirmTransitForm.patchValue({
                  Decision: this.decisionValue ,
                  TransitDate: new Date(this.smallunitRequestObj.ISMarineConfirmTransitDate),
                  MoreInformation: this.smallunitRequestObj.ISMarineConfirmMoreInformation
                });
              }
              this.formMode = FormMode.Readonly;
              this.ISMconfirmTransitForm.disable();
            }
            else if(this.requestStatus == ServiceStatus.SmallUnit_PendingISMTransitConfirmation_PendingFinalFees){
              this.formMode = FormMode.Add;
              this.ISMconfirmTransitForm.enable();
            }
            else{
              this.formMode = FormMode.Readonly;
              this.ISMconfirmTransitForm.disable();
              this.decisionValue = this.smallunitRequestObj.ISMarineConfirmActionId;
              if (this.smallunitRequestObj.ISMarineConfirmActionId == SUIsmConfirmTransitDecision.ISM_Postpone) {
                this.buildForm(this.decisionValue);
                this.ISMconfirmTransitForm.patchValue({
                  Decision: this.decisionValue,
                  MoreInformation: this.smallunitRequestObj.ISMarineConfirmMoreInformation
                });
              }
              else {
                this.decisionValue = this.smallunitRequestObj.ISMarineConfirmActionId;
                this.buildForm(this.decisionValue);
                this.ISMconfirmTransitForm.patchValue({
                  Decision: this.decisionValue,
                  TransitDate: new Date(this.smallunitRequestObj.ISMarineConfirmTransitDate),
                  MoreInformation: this.smallunitRequestObj.ISMarineConfirmMoreInformation
                });
              }

            }
          }
        }
      )
    }


    onSubmit(b) {

      this.submitted = true;
      // stop here if form is invalid
      if (this.ISMconfirmTransitForm.invalid) {
        return;
      }
      this.alertService.clear();
      this.globalSrv.isLoaderEnabled = true;
      this.loading = true;

     // this.adminDecisionObject = this.confirmTransitForm.value;
      this.adminDecisionObject.AdminEmail = this.user.UserName;
      this.adminDecisionObject.Id = this.baseRequestId;
      this.adminDecisionObject.ISMarineConfirmActionId = this.ISMconfirmTransitForm.controls.Decision.value;
      this.adminDecisionObject.ISMarineConfirmMoreInformation = this.ISMconfirmTransitForm.controls.MoreInformation.value;
      //This flag is used to distinguish whether the component in final fees review or final fees only
      this.adminDecisionObject.IsFinalFeesReview = this.smallunitRequestObj.IsFinalFeesReview;
      //this value is passed to backend to also distinguish whether the component in final fees review or final fees only
      this.adminDecisionObject.FinalTotalFees = this.smallunitRequestObj.FinalTotalFees;
      if (this.ISMconfirmTransitForm.get("TransitDate") != null && this.ISMconfirmTransitForm.get("TransitDate").value) {
          var selectedTransitDate = this.ISMconfirmTransitForm.get("TransitDate").value.toLocaleString('en-US');
          this.ISMconfirmTransitForm.controls['TransitDate'].setValue(selectedTransitDate);
          this.adminDecisionObject.ISMarineConfirmTransitDate = this.ISMconfirmTransitForm.controls.TransitDate.value;
      }

      this.SmallUnitAdminServ.ISMConfirmTransitDecision(this.adminDecisionObject)
        .subscribe(
          (data: ResponseObject) => {
            if (data.Success) {
              this.globalSrv.isLoaderEnabled = false;
              //this.alertService.success('Decision Submitted Successfully', false);
              this.ISMconfirmTransitForm.reset();
              this.loading = false;
              this.showRequest = true;
              this.isErrorMessage = false;
            }
            else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
              this.lockTaskErrorMessage = true;
              this.showRequest = true;
              this.globalSrv.isLoaderEnabled = false;
            }
            else {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = true;
              //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.'+data.ErrorMessages[0]), false);

              this.loading = false;
            }

          });
    }
  }
